import { architeckCall } from 'database';
import keys from 'keys';
import React from "react";
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardHeader, Col, FormGroup, Input, Row } from "reactstrap";
import { toggleAlert } from 'store/functions/system';

const required_form_fields = [
    'timeline',
    'type',
    'description',
]

class Profile extends React.Component {

    state = {
        request: {
            user: this.props.viewing_user._id,
            project: this.props.project._id,
            company: this.props.project.company._id,
        },
        canSave: true
    }

    onSave = async () => {

        this.setState({canSave: false})
        //copy state
        let newState = Object.assign({}, this.state.request);
        //assume we have no errors
        let errors = 0;

        required_form_fields.forEach((field) => {
            //check each required field
            if(newState[field]) {
                newState[field + "State"] = 'valid'; 
            } else {
                newState[field + "State"] = 'invalid'; 
                errors++
            }

        })

        this.setState({ request: newState });

        if(!errors) { 

            const created = await architeckCall({
                method: 'post',
                url: '/api/v1/crud/requests/create',
                data: newState,
            });

            if(created.success) {

                    //reset request
                this.setState({request: {
                    user: this.props.viewing_user._id,
                    project: this.props.project._id,
                    company: this.props.project.company._id,
                }})

                const url = window.location.hostname === 'localhost' ? 'http://localhost:3000' : 'https://master.architeck.io'

                const email = await architeckCall({
                    method: 'POST',
                    url: '/api/v1/integrations/sengrid/branded',
                    data: {
                        "to": "john@architeck.io",
                        "from": "webmaster@architeck.io",
                        "subject": `New Request Was Submitted On Project ${this.props.project.name}`,
                        "title": "New Feature Request",
                        "body": `You may view feature request through your secured <a href='${url}/admin/projects/view/${this.props.project._id}'>dashboard portal here</a> `
                    }
                }) 
        
                if(email.success) {
                    //send success alert
                    toggleAlert(true, 'success', 'Your request has been submitted.', '4000' )

                } else {
                    //send failure alert
                    console.log(email)
                    toggleAlert(true, 'danger', 'System error, please send details of your update / feature request to john@architeck.io', 'infinite' )

                }


            } else {

                console.log(created)
                toggleAlert(true, 'danger', 'System error, please send details of your update / feature request to john@architeck.io', 'infinite' )

            }

        }

        //after load make sure button work again
        this.setState({canSave: true})

    }

    onInputChange = (e, stateName) => {

        let newState = Object.assign({}, this.state.request);
        newState[stateName] = e.target.value;

        if (stateName === "checkbox") {
          if (e.target.value) {
            newState.checkboxState = "valid";
          } else {
            newState.checkboxState = "invalid";
          }
        } else {
          if (e.target.value === "") {
            newState[stateName + "State"] = "invalid";
          } else {
            newState[stateName + "State"] = "valid";
          }
        }

        this.setState({ request: newState });
    };

  
    
    render() {

        return (
            <Card>

                {this.state.alert}

                <CardHeader>
                    <Row className="align-items-center">
                        <Col xs="8">
                            <h3 className="mb-0">It's Update Time!</h3>
                        </Col>
                    </Row>
                </CardHeader>

                <CardBody>

                    <Row>
                        <Col lg="6">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="type" > 
                                    I want to: 
                                </label>
                                <Input
                                    id="type"
                                    value={this.state.request.type || ''}
                                    type="select"
                                    valid={ this.state.request.typeState === "valid" }
                                    invalid={ this.state.request.typeState === "invalid" }
                                    onChange={e => this.onInputChange(e, "type") }
                                >
                                    <option>Select One</option>
                                    <option value="Add A Page(s)">Add A Page(s)</option>
                                    <option value="Create An Integration">Create An Integration</option>
                                    <option value="Improve Design">Improve Design</option>
                                    <option value="Implement Feature">Implement Feature</option>
                                    <option value="Request A Revision">Request A Revision</option>
                                    <option value="Talk To An Architeck Specialist">Talk To An Architeck Specialist</option>
                                    <option value="Something Else">Something Else</option>
                                </Input>
                                <div className="valid-feedback">Looks good!</div>
                            </FormGroup>
                        </Col>
                        <Col lg="6">
                            <FormGroup>
                                <label className="form-control-label" htmlFor="timeline" > 
                                    I would like this done within:
                                </label>
                                <Input
                                    id="timeline"
                                    value={this.state.request.timeline || ''}
                                    type="select"
                                    valid={ this.state.request.timelineState === "valid" }
                                    invalid={ this.state.request.timelineState === "invalid" }
                                    onChange={e => this.onInputChange(e, "timeline") }
                                >
                                    <option>Select One</option>
                                    <option>1 - 2 Weeks</option>
                                    <option value="1 Month">1 Month</option>
                                    <option value="2-3 Months">2-3 Months</option>
                                    <option value="3-6 Months">3-6 Months</option>
                                    <option value="6 Months +">6 Months +</option>
                                </Input>
                                <div className="valid-feedback">Looks good!</div>
                            </FormGroup>
                        </Col>
                    </Row>

                    <FormGroup>
                        <label className="form-control-label" htmlFor="description" > 
                            What I would like to accomplish with this is:
                        </label>
                        <Input
                            style={{minHeight: 300}}
                            id="description"
                            value={this.state.request.description || ''}
                            placeholder="I would like to add... The end goal of doing this is... etc..."
                            type="textarea"
                            valid={ this.state.request.descriptionState === "valid" }
                            invalid={ this.state.request.descriptionState === "invalid" }
                            onChange={e => this.onInputChange(e, "description") }
                        />
                        <div className="valid-feedback">Looks good!</div>
                    </FormGroup>

                    <div className="mt-3 text-right">
                        <Button onClick={this.onSave} className="btn btn-success">Submit</Button>
                    </div>
            
                </CardBody>
            </Card>
        );
    }
}



const mapStateToProps = state => {
    return {
  
      viewing_user: state.auth.viewing_user,
  
    };
};
  
export default connect(mapStateToProps, '')(Profile);